/* =========================================================
   YLF – interactieve plannerkeuzehulp
   ========================================================= */

(function () {
  'use strict';

  var adviceData = {
    'wood-week-base': {
      title: 'Houten weekplanner met basisset',
      label: 'Ons advies • rustig hout',
      text:
        'Jullie hebben vooral behoefte aan overzicht over meerdere dagen. De houten weekplanner laat de hele week zien in een rustige, natuurlijke vorm met weinig kleur.',
      image:
        'https://www.yourlittlefamily.com/cdn/shop/files/458778160_868374728590206_9094151863471852043_n.jpg?v=1776494124&width=900',
      benefits: [
        'Overzicht van maandag tot en met zondag',
        'Inclusief 46 houten pictogrammen',
        'Rustige en prikkelarme uitstraling',
        'Later uit te breiden met losse houten pictogrammen'
      ],
      reason:
        'De volledige week wordt zichtbaar zonder dat het beeld erg kleurrijk wordt. Dat past goed wanneer rust en weinig visuele prikkels belangrijk zijn.',
      link: '/products/weekplanner-hout-46-pictogrammen',
      button: 'Bekijk de houten weekplanner',
      magnetic: false
    },

    'wood-week-custom': {
      title: 'Houten weekplanner zelf samenstellen',
      label: 'Ons advies • rustig en persoonlijk',
      text:
        'Een houten weekplanner past bij jullie behoefte aan overzicht en rust. Omdat je zelf de pictogrammen wilt kiezen, kun je hem precies laten aansluiten op jullie eigen weekritme.',
      image:
        'https://www.yourlittlefamily.com/cdn/shop/files/Legeweekplanner1.jpg?v=1737640447&width=900',
      benefits: [
        'Rustig en natuurlijk houten ontwerp',
        'Zelf bepalen welke pictogrammen jullie gebruiken',
        'Passend bij een eigen of afwijkend weekritme',
        'Later eenvoudig verder uit te breiden'
      ],
      reason:
        'Je combineert een prikkelarme uitstraling met pictogrammen die herkenbaar zijn voor jullie eigen gezin.',
      link: '/pages/planner-zelf-samenstellen',
      button: 'Stel de houten planner samen',
      magnetic: false
    },

    'magnet-week-base': {
      title: 'Magnetische weekplanner met basisset',
      label: 'Ons advies • nieuw en magnetisch',
      text:
        'Jullie willen de hele week zichtbaar maken en vinden kleur en flexibiliteit prettig. De magnetische weekplanner geeft overzicht van maandag tot en met zondag en werkt met ronde magneten die snel te verplaatsen zijn.',
      image:
        'https://www.yourlittlefamily.com/cdn/shop/files/FOTO_1.webp?v=1784007872&width=900',
      benefits: [
        'Ruim magnetisch planbord van 40 × 60 cm',
        'Inclusief 45 magnetische pictogrammen',
        'Kleurrijke en moderne uitstraling',
        'Pictogrammen gemakkelijk verplaatsen en wisselen'
      ],
      reason:
        'Deze planner past wanneer je kind kleur prettig vindt en jullie de week gemakkelijk willen kunnen aanpassen.',
      link:
        '/products/magnetische-weekplanner-kind-met-basisset-pictogrammen',
      button: 'Bekijk de magnetische weekplanner',
      magnetic: true
    },

    'magnet-week-custom': {
      title: 'Magnetische weekplanner zelf samenstellen',
      label: 'Ons advies • magnetisch op maat',
      text:
        'Jullie willen weekoverzicht, kleur en vrijheid om zelf te bepalen welke activiteiten op de planner komen. Met de magnetische weekplanner zonder basisset kies je alle pictogrammen afzonderlijk.',
      image:
        'https://www.yourlittlefamily.com/cdn/shop/files/Weekplanner_leeg.webp?v=1785688920&width=900',
      benefits: [
        'Magnetisch planbord van 40 × 60 cm',
        'Geen vaste pictogrammen die jullie niet gebruiken',
        'Zelf alle magnetische pictogrammen kiezen',
        'Passend bij jullie eigen weekritme'
      ],
      reason:
        'De planner is kleurrijk en flexibel, terwijl je alleen magneten kiest die echt iets toevoegen aan jullie planning.',
      link:
        '/products/magnetische-weekplanner-zelf-samenstellen-kies-zelf-je-magnetische-pictogrammen?variant=57347969352055',
      button: 'Stel de magneetplanner samen',
      magnetic: true
    },

    'wood-day-base': {
      title: 'Houten dagplanner met basisset',
      label: 'Ons advies • één rustige dag',
      text:
        'Eén dag tegelijk lijkt voor jullie kind het meest overzichtelijk. De houten dagplanner maakt ochtend, middag en avond zichtbaar zonder meteen de hele week te tonen.',
      image:
        'https://www.yourlittlefamily.com/cdn/shop/files/Dagplanner_2.jpg?v=1750156280&width=900',
      benefits: [
        'Eén dag stap voor stap zichtbaar',
        'Rustige houten uitstraling',
        'Fijn voor jonge of prikkelgevoelige kinderen',
        'Met pictogrammen en vinkmomenten'
      ],
      reason:
        'Je houdt de hoeveelheid informatie klein en kiest voor een rustig beeld met weinig kleur.',
      link: '/products/dagplanner-hout-47-pictogrammen-extra',
      button: 'Bekijk de houten dagplanner',
      magnetic: false
    },

    'wood-day-custom': {
      title: 'Houten dagplanner zelf samenstellen',
      label: 'Ons advies • één dag op maat',
      text:
        'Een rustige dagplanner past goed, maar jullie willen zelf bepalen welke activiteiten zichtbaar worden. Zo sluit de planner precies aan op jullie ochtend, middag en avond.',
      image:
        'https://www.yourlittlefamily.com/cdn/shop/files/Dagplanner_2.jpg?v=1750156280&width=900',
      benefits: [
        'Overzicht van één dag tegelijk',
        'Zelf passende houten pictogrammen kiezen',
        'Rustige en natuurlijke uitstraling',
        'Geschikt voor specifieke routines'
      ],
      reason:
        'De beperkte hoeveelheid informatie geeft rust, terwijl zelfgekozen pictogrammen voor extra herkenning zorgen.',
      link: '/pages/planner-zelf-samenstellen',
      button: 'Stel de houten dagplanner samen',
      magnetic: false
    },

    'magnet-day': {
      title: 'Magnetische dagplanner',
      label: 'Ons advies • kleurrijk dagoverzicht',
      text:
        'Eén dag tegelijk past het beste, maar jullie vinden kleur en gemakkelijk verplaatsen prettig. De magnetische dagplanner laat activiteiten stap voor stap zien en gebruikt magnetische vinkjes om af te ronden wat klaar is.',
      image:
        'https://www.yourlittlefamily.com/cdn/shop/files/Dagplanner.webp?v=1784273781&width=900',
      benefits: [
        'Eén dag stap voor stap zichtbaar',
        'Inclusief magnetische pictogrammen en vinkjes',
        'Kleurrijke en moderne uitstraling',
        'Uit te breiden met losse magnetische pictogrammen'
      ],
      reason:
        'Je kind krijgt een compact dagoverzicht, terwijl de magneten snel kunnen worden verplaatst wanneer de dag anders loopt.',
      link: '/collections/magneet-dagplanner',
      button: 'Bekijk de magnetische dagplanner',
      magnetic: true
    },

    routine: {
      title: 'Houten dag- en avondroutine',
      label: 'Ons advies • vaste stappen',
      text:
        'De meeste winst lijkt bij terugkerende ochtend- of avondmomenten te liggen. De routineset maakt zichtbaar welke stap nu komt en wat al is afgerond.',
      image:
        'https://www.yourlittlefamily.com/cdn/shop/files/Sietske_voorpagina_3.jpg?v=1736776508&width=900',
      benefits: [
        'Voor opstaan, aankleden en naar bed gaan',
        'Vaste stappen in een duidelijke volgorde',
        'Rustige houten uitstraling',
        'Helpt bij meer zelfstandigheid'
      ],
      reason:
        'Bij vaste routines is niet een hele dag of week nodig. Een korte reeks herkenbare stappen geeft vaak precies genoeg ondersteuning.',
      link: '/collections/dag-avondroutine',
      button: 'Bekijk de routineset',
      magnetic: false
    }
  };

  function initializePlannerGuide(root) {
    if (!root || root.dataset.ylfInitialized === 'true') {
      return;
    }

    root.dataset.ylfInitialized = 'true';

    var currentStep = 0;
    var answers = {};

    var questions = Array.prototype.slice.call(
      root.querySelectorAll('.ylf-planner-guide-top__question')
    );

    var dots = Array.prototype.slice.call(
      root.querySelectorAll('.ylf-planner-guide-top__dot')
    );

    var previousButton = root.querySelector('[data-ylf-prev]');
    var nextButton = root.querySelector('[data-ylf-next]');
    var progress = root.querySelector('[data-ylf-progress]');
    var quizSection = root.querySelector('[data-ylf-section="quiz"]');
    var result = root.querySelector('[data-ylf-result]');
    var scrollButton = root.querySelector('[data-ylf-scroll="quiz"]');

    if (
      !questions.length ||
      !previousButton ||
      !nextButton ||
      !progress ||
      !quizSection ||
      !result
    ) {
      return;
    }

    function scrollToElement(element) {
      if (!element) {
        return;
      }

      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    function showTemporaryMessage(message) {
      var originalText = nextButton.textContent;

      nextButton.textContent = message;
      nextButton.disabled = true;

      window.setTimeout(function () {
        nextButton.disabled = false;
        nextButton.textContent = originalText;
      }, 1200);
    }

    function countFocus(key) {
      var total = 0;

      ['0', '1', '2'].forEach(function (stepNumber) {
        if (answers[stepNumber] === key) {
          total += 1;
        }
      });

      return total;
    }

    function showStep() {
      questions.forEach(function (question, index) {
        question.classList.toggle('is-active', index === currentStep);
      });

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === currentStep);

        if (index === currentStep) {
          dot.setAttribute('aria-current', 'step');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      previousButton.style.visibility =
        currentStep === 0 ? 'hidden' : 'visible';

      nextButton.textContent =
        currentStep === questions.length - 1
          ? 'Toon mijn advies'
          : 'Volgende';

      progress.textContent =
        'Stap ' + (currentStep + 1) + ' van ' + questions.length;
    }

    function firstUnansweredStep() {
      var unanswered = -1;

      questions.some(function (question, index) {
        var stepNumber = question.getAttribute('data-step');

        if (!answers[stepNumber]) {
          unanswered = index;
          return true;
        }

        return false;
      });

      return unanswered;
    }

    function determineAdvice() {
      var dayScore = countFocus('day');
      var weekScore = countFocus('week');
      var routineScore = countFocus('routine');
      var setup = answers['3'] || 'base';
      var material = answers['4'] || 'neutral';
      var focus = 'week';

      if (routineScore >= 2) {
        focus = 'routine';
      } else if (dayScore > weekScore) {
        focus = 'day';
      }

      if (focus === 'routine') {
        return 'routine';
      }

      /*
       * Zonder materiaalvoorkeur adviseren we hout als rustige basis.
       * De bezoeker kan onder het advies beide systemen vergelijken.
       */
      if (material === 'neutral') {
        material = 'wood';
      }

      if (focus === 'day') {
        if (material === 'magnet') {
          return 'magnet-day';
        }

        return setup === 'custom'
          ? 'wood-day-custom'
          : 'wood-day-base';
      }

      if (material === 'magnet') {
        return setup === 'custom'
          ? 'magnet-week-custom'
          : 'magnet-week-base';
      }

      return setup === 'custom'
        ? 'wood-week-custom'
        : 'wood-week-base';
    }

    function showResult() {
      var unansweredStep = firstUnansweredStep();

      if (unansweredStep !== -1) {
        currentStep = unansweredStep;
        showStep();
        scrollToElement(quizSection);
        showTemporaryMessage('Kies eerst een antwoord');
        return;
      }

      var adviceKey = determineAdvice();
      var selectedAdvice = adviceData[adviceKey];

      if (!selectedAdvice) {
        return;
      }

      var title = result.querySelector('[data-ylf-result-title]');
      var label = result.querySelector('[data-ylf-result-label]');
      var text = result.querySelector('[data-ylf-result-text]');
      var image = result.querySelector('[data-ylf-result-image]');
      var benefits = result.querySelector('[data-ylf-benefits]');
      var reason = result.querySelector('[data-ylf-reason]');
      var resultLink = result.querySelector('[data-ylf-result-link]');

      if (
        !title ||
        !label ||
        !text ||
        !image ||
        !benefits ||
        !reason ||
        !resultLink
      ) {
        return;
      }

      title.textContent = selectedAdvice.title;
      label.textContent = selectedAdvice.label;
      text.textContent = selectedAdvice.text;
      reason.textContent = selectedAdvice.reason;

      image.style.backgroundImage =
        "url('" + selectedAdvice.image + "')";

      resultLink.href = selectedAdvice.link;
      resultLink.textContent = selectedAdvice.button;

      benefits.innerHTML = '';

      selectedAdvice.benefits.forEach(function (benefitText) {
        var listItem = document.createElement('li');
        listItem.textContent = benefitText;
        benefits.appendChild(listItem);
      });

      result.classList.toggle(
        'is-magnetic',
        selectedAdvice.magnetic === true
      );

      result.classList.add('is-visible');

      scrollToElement(result);
    }

    root
      .querySelectorAll('.ylf-planner-guide-top__answer')
      .forEach(function (answer) {
        answer.addEventListener('click', function () {
          var question = answer.closest(
            '.ylf-planner-guide-top__question'
          );

          if (!question) {
            return;
          }

          question
            .querySelectorAll('.ylf-planner-guide-top__answer')
            .forEach(function (item) {
              item.classList.remove('is-selected');
              item.setAttribute('aria-pressed', 'false');
            });

          answer.classList.add('is-selected');
          answer.setAttribute('aria-pressed', 'true');

          answers[question.getAttribute('data-step')] =
            answer.getAttribute('data-key');
        });
      });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var requestedStep = Number(dot.getAttribute('data-go'));

        if (
          Number.isNaN(requestedStep) ||
          requestedStep < 0 ||
          requestedStep >= questions.length
        ) {
          return;
        }

        currentStep = requestedStep;
        showStep();
        scrollToElement(quizSection);
      });
    });

    previousButton.addEventListener('click', function () {
      if (currentStep > 0) {
        currentStep -= 1;
      }

      showStep();
    });

    nextButton.addEventListener('click', function () {
      var currentQuestion = questions[currentStep];
      var stepNumber = currentQuestion.getAttribute('data-step');

      if (!answers[stepNumber]) {
        var firstAnswer = currentQuestion.querySelector(
          '.ylf-planner-guide-top__answer'
        );

        if (firstAnswer) {
          firstAnswer.focus();
        }

        showTemporaryMessage('Kies eerst een antwoord');
        return;
      }

      if (currentStep < questions.length - 1) {
        currentStep += 1;
        showStep();
      } else {
        showResult();
      }
    });

    if (scrollButton) {
      scrollButton.addEventListener('click', function () {
        scrollToElement(quizSection);
      });
    }

    showStep();
  }

  function initializeAllPlannerGuides(container) {
    var searchArea = container || document;

    searchArea
      .querySelectorAll('[data-ylf-planner-guide]')
      .forEach(initializePlannerGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAllPlannerGuides(document);
    });
  } else {
    initializeAllPlannerGuides(document);
  }

  /*
   * Zorgt dat de keuzehulp ook blijft werken wanneer Shopify de
   * sectie opnieuw laadt in de thema-editor.
   */
  document.addEventListener('shopify:section:load', function (event) {
    initializeAllPlannerGuides(event.target);
  });
})();